import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20a%20colorful%20contemporary%20streetwear%20wardrobe%20including%20a%20sage%20green%20hoodie%2C%20cream%20sneakers%2C%20a%20washed%20denim%20jacket%20and%20a%20navy%20baseball%20cap%20arranged%20artfully%20on%20a%20warm%20beige%20studio%20background%2C%20soft%20natural%20light%2C%20airy%20modern%20western%20editorial%20aesthetic%2C%20high%20detail%2C%20balanced%20composition&width=1600&height=900&seq=usfans-hero-2&orientation=landscape"
          alt="USFans Spreadsheet — curated streetwear and fashion product collection"
          title="USFans Spreadsheet streetwear collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-8 py-20 md:py-32 text-center">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-xs font-medium">
          <i className="ri-sparkling-line"></i>
          {t('home.hero.badge')}
        </span>

        <h1 className="mt-6 text-3xl md:text-5xl font-bold text-background-50 leading-tight tracking-tight">
          {t('home.hero.title')}
        </h1>

        <p className="mt-5 text-base md:text-lg text-background-100/90 leading-relaxed max-w-2xl mx-auto">
          {t('home.hero.subtitle')}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 rounded-md bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            {t('home.hero.primaryCta')}
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 rounded-md bg-background-50 text-foreground-950 font-semibold text-sm hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            {t('home.hero.secondaryCta')}
          </a>
        </div>

        <p className="mt-6 text-xs text-background-100/70">{t('home.hero.trust')}</p>
      </div>
    </section>
  );
}